<template>
    <div class="line-container" style="line-height: 2;">
        <el-row>
            <el-col :span="24">
                <el-row>
                    <el-col :span="12">
                        测量范围
                    </el-col>
                    <el-col :span="12">
                        不确定度/准确度等级/最大允许误差
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "table-show-range-head"
    }
</script>

<style>
    .line-container .el-row{
        display: flex;
        align-items: center;
    }
    .line-container .el-row.header{
        border-bottom: none;
    }
    .line-container .el-row:last-child{
        border-bottom: none;
    }
</style>